<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-15 09:56:59
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-20 16:57:15
-->
<template>
  <div class="innovative intracranial" :class="{textj: language != 'en'}">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require(`@/assets/images/m/innovate${language == 'en' ? '/en' : ''}/skull_bj.png`)" alt="" srcset="">
      <div v-if="language != 'en'" class="innovative-bj-txt" @click="$router.push({ path: language == 'en' ? '/en/guidance' :'/guidance' })"></div>
    </div>
    <div class="innovative-container">
      <img @contextmenu="($event) => {$event.returnValue = false; return false}" @dragstart.prevent class="wid100" :src="$t('product.skull.m_processImg')" alt="" srcset="">
    </div>
    <div class="innovative-intelligence p-b-10">
      <div class="innovative-container textj">
        <div class="innovative-wrap-item-title textc color_active" :style="{textc: language != 'en'}">{{$t('product.skull.intelligence.title').join(' ')}}</div>
        <div>
          <p v-for="item, index in $t('product.skull.intelligence.des')" :key="index" v-html="item"></p>
        </div>
      </div>
      <img class="wid100" :src="$t('product.skull.intelligence.m_img')" alt="" srcset="">
    </div>
    <div class="innovative-container">
      <div class="innovative-wrap-item p-b-30 innovative-advantages">
        <div class="innovative-wrap-item-title textc color_active">{{$t('product.skull.coreAdvantages.title')}}</div>
        <div class="textj">
          <p class="p-b-30 innovative-characteristics-item" v-for="item, index in $t('product.skull.coreAdvantages.des')" :key="index" v-html="item"></p>
        </div>
        <div class="p-t-10 p-b-30">
          <img class="wid100" :src="$t('product.skull.coreAdvantages.img')" alt="" srcset="">
        </div>
        <el-row class="flex flex_wrap">
          <el-col :span="language == 'en' ? 24 : 12" class="innovative-advantages-item" :class="{textc: language == 'zh', flex: language == 'en'}" v-for="item, index in $t('product.skull.coreAdvantages.list')" :key="index">
            <div class="innovative-advantages-item-img">
              <img class="" :src="item.img" alt="" srcset="">
            </div>
            <div :class="{flex_1: language == 'en', 'p-l-30': language == 'en'}">
              <div class="innovative-advantages-item-title p-t-0">{{item.title}}</div>
              <p>{{item.des}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="innovative-products innovative-wrap-item">
      <div class="innovative-products-title innovative-wrap-item-title textc p-b-36 color_active">{{$t('product.skull.relatedProducts.title')}}</div>
      <div class="swiper-container swiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in $t('product.skull.relatedProducts.list')" :key="index">
            <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" :data-path="item.path" :data-disabled="item.disabled">
              <div class="innovative-products-mask flex justify_content_center align_items_center" v-if="item.disabled"><span class="txt">敬请期待</span></div>
              <img class="wid100" :src="item.img" alt="" srcset="">
              <div class="innovative-products-item-title ellipsis" v-html="item.title"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper1-pagination"></div>
      </div>
    </div>
    <div class="">
      <div class="innovative-container">
        <div class="innovative-wrap-item-title textc color_active" v-html="$t('product.skull.stroke.title')"></div>
        <div class="textj">
          <p v-for="item, index in $t('product.skull.stroke.des')" :key="index" v-html="item"></p>
        </div>
      </div>
      <img class="wid100" :src="$t('product.skull.stroke.bjImgM')" alt="" srcset="">
    </div>
    <div>
      <div class="innovative-container innovative-stroke-summary-box">
        <div class="textc p-t-30">
          <div class="innovative-wrap-item-title textc" v-html="$t('product.skull.stroke.summary.des')[1]"></div>
          <div class="innovative-stroke-summary-sign" v-html="$t('product.skull.stroke.summary.des')[2]"></div>
          <div class="flex justify_content_end p-t-45 p-b-10">
            <div class="innovative-stroke-summary-tooltip" v-html="$t('product.skull.stroke.summary.des')[0]"></div>
          </div>
        </div>
        <img class="wid100" :src="$t('product.skull.stroke.summary.img')" alt="" srcset="">
        <div class="p-t-30">
          <div class="p-l-15 innovative-characteristics-item" v-for="item, index in $t('product.skull.stroke.list')" :key="index" v-html="item"></div>
        </div>
      </div>
      <div>
        <div class="innovative-products">
          <div class="innovative-products-title textc p-t-24 p-b-36 color_active">{{$t('product.skull.stroke.products.title')}}</div>
          <div class="swiper-container swiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in $t('product.skull.stroke.products.list')" :key="index">
                <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" :data-path="item.path" :data-disabled="item.disabled">
                  <img class="wid100" :src="item.img" alt="" srcset="">
                  <div class="innovative-products-item-title ellipsis" v-html="item.title"></div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination swiper2-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-wrap-item p-t-120 p-b-60">
      <div class="innovative-container p-t-1 p-b-1">
        <div class="innovative-wrap-item-title color_active textc">
        <p v-for="(item, index) in $t('product.skull.narrow.title')" :key="index" v-html="item"></p>
        </div>
        <div class="innovative-narrow-des p-b-30" :class="language == 'en' ? 'textj' : 'textl'" v-html="$t('product.skull.narrow.des')"></div>
      </div>
      <img class="wid100" :src="$t('product.skull.narrow.MbjImg')" alt="" srcset="">
      <div class="innovative-container p-t-0 p-b-0">
        <div class="p-t-30 p-b-30 textj">
          <p class="flex align_items_center" v-for="item, index in $t('product.skull.narrow.list')" :key="index" v-html="item"></p>
        </div>
        <img class="" :src="$t('product.skull.narrow.summary.img')" alt="" srcset="">
        <div v-if="language == 'zh'" class="p-t-30 p-b-68 justify_content_center flex">
          <div class="flex" v-for="item, index in $t('product.skull.narrow.summary.des')" :key="index">
            <p v-if="index !== 0" class="p-l-12 p-r-12">•</p>
            <p class="flex_1" v-html="item"></p>
          </div>
        </div>
        <div v-else class="p-t-36 p-b-80 justify_content_center p-l-20">
          <div class="flex p-r-20 p-l-20 nowrap p-t-8 p-b-8" v-for="item, index in $t('product.skull.narrow.summary.des')" :key="index">
            <div>
              <img class="icon-diamond" :src="require('@/assets/images/icons/diamond.png')" alt="" srcset="">
            </div>
            <p class="p-l-15 flex_1" v-html="item"></p>
          </div>
        </div>
        <div class="innovative-products">
          <div class="innovative-products-title textc p-b-26 color_active">{{$t('product.skull.narrow.products.title')}}</div>
          <div class="swiper-container swiper3">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in $t('product.skull.narrow.products.list')" :key="index">
                <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" @click="$router.push({ path: item.path })">
                  <img class="wid100" :src="item.img" alt="" srcset="">
                  <div class="innovative-products-item-title ellipsis" v-html="item.title"></div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination swiper3-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
    this.mySwiper1 = this.initSwiper('.swiper1')
    this.mySwiper2 = this.initSwiper('.swiper2')
    // this.mySwiper3 = this.initSwiper('.swiper3')
  },
  methods: {
    initSwiper (el) {
      return new this.$Swiper(el, {
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        spaceBetween: 16,
        // 切换效果
        effect: 'coverflow',
        // 该选项给Swiper用户提供小小的贴心应用，设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。
        grabCursor: true,
        // 设定为true时，active slide会居中，而不是默认状态下的居左。
        centeredSlides: true,
        // 设置slider容器能够同时显示的slides数量(carousel模式)。
        slidesPerView: 1.2,
        // 启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。默认false，不开启，可以使用update()方法更新。
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        // 自动切换
        autoplay: {
          // 自动切换的时间间隔
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换
          stopOnLastSlide: false,
          // 用户操作swiper之后，是否禁止autoplay。默认为true：停止
          disableOnInteraction: false
        },
        // 类似于苹果将多首歌曲的封面以3D界面的形式显示出来的方式
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          stretch: -50,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          depth: 400,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          modifier: 1,
          // 是否开启slide阴影
          slideShadows: true
        },
        pagination: {
          el: `${el}-pagination`
        },
        on: {
          click: (e) => {
            if (!e.target.dataset.disabled) {
              this.$router.push({ path: e.target.dataset.path })
            }
          }
        }
      })
    }
  },
  destroyed () {
    this.mySwiper1 = null
    this.mySwiper2 = null
    this.mySwiper3 = null
  }
}
</script>
<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative.intracranial {
  .innovative-advantages .innovative-advantages-item {
    padding: 30px 4% 60px 4%;
    .innovative-advantages-item-title {
      color: #333333;
      font-size: 28px;
      line-height: 40px;
      padding: 34px 0 24px 0;
      font-weight: 600;
    }
    .innovative-advantages-item-img {
      height: 136px;
      img {
        max-height: 100%;
      }
    }
  }
  .innovative-stroke-summary-box {
    background: #F8FBFF;
    .innovative-wrap-item-title {
      font-size: 30px;
      letter-spacing: 5.4px;
      padding-bottom: 0;
    }
    .innovative-stroke-summary-sign {
      background: linear-gradient(90deg, #0556EA 0%, #02C2D0 100%);
      color: #ffffff;
      display: inline-block;
      padding: 0 25px;
      margin-top: 10px;
      font-size: 16px;
    }
    .innovative-stroke-summary-tooltip {
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 3px rgba(62,115,224,0.21);
      border-radius: 11px;
      padding: 12px 17px;
      line-height: 38px;
      display: inline-block;
      position: relative;
      right: 20px;
    }
  }
}

.m.en .innovative.intracranial {
  .innovative-stroke-summary-box {
    .innovative-wrap-item-title {
      letter-spacing: 3px;
    }
    .innovative-stroke-summary-sign {
      font-size: 14px;
    }
    .innovative-stroke-summary-tooltip {
      font-size: 20px;
    }
  }
}
</style>
